import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import ScheduleScreen from '../screen'
import ExperienceScreen from '../../experience/details-screen'
import DropExperienceScreen from '../../experience/drop-screen'
import EnrollExperienceScreen from '../../experience/enroll-screen'
import PreviewSchedule from '../preview'
import ScheduleConflicts from '../conflicts'

const SurveysRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.SCHEDULE} component={ScheduleScreen} />
            <Route exact path={`${CLIENT_ENDPOINTS.SCHEDULE}${CLIENT_ENDPOINTS.EXPERIENCE}`} component={ExperienceScreen} />
            <Route exact path={`${CLIENT_ENDPOINTS.SCHEDULE}${CLIENT_ENDPOINTS.EXPERIENCE}${CLIENT_ENDPOINTS.PREVIEW_SCHEDULE}`} component={PreviewSchedule} />
            <Route exact path={`${CLIENT_ENDPOINTS.SCHEDULE}${CLIENT_ENDPOINTS.EXPERIENCE}${CLIENT_ENDPOINTS.CONFLICTS}`} component={ScheduleConflicts} />
            <Route exact path={`${CLIENT_ENDPOINTS.SCHEDULE}${CLIENT_ENDPOINTS.EXPERIENCE}${CLIENT_ENDPOINTS.DROP}`} component={DropExperienceScreen} />
            <Route exact path={`${CLIENT_ENDPOINTS.SCHEDULE}${CLIENT_ENDPOINTS.EXPERIENCE}${CLIENT_ENDPOINTS.ENROLL}`} component={EnrollExperienceScreen} />
        </React.Fragment>
    )
}

export default SurveysRoutes